
import firebaseApp from './firebaseApp'
import 'firebase/auth'
import firebase from 'firebase'
const auth = firebaseApp.auth();

export default auth